import { render } from "./PR45-12102024.vue?vue&type=template&id=1c122802"
import script from "./PR45-12102024.vue?vue&type=script&lang=js"
export * from "./PR45-12102024.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__